import React from 'react';

import LetUsCallYouModal from '@components/ui/LetUsCallYou/LetUsCallYouModal';
import useCallMeFrom from '@components/views/hooks/useCallMeFrom';
import { ApiError } from '@api/index';
import { useToggle } from '@hooks/common';
import { useSkipEffectOnMount } from '@hooks/lifecycle';

import { LetUsCallYouProps } from './types';
import SuccessModal from '../modals/SuccessModal';

const LetUsCallYou = ({
  entityId,
  entityName,
  price,
  currency,
  salesItemType,
  availabilityStatus,
  onClose,
  formCheckInDate,
  formCheckOutDate,
  hotelRoomList,
  onFormSendSuccess,
  alertType,
  token,
  itemCountryCode,
  showSuccessModal = true,
}: LetUsCallYouProps) => {
  const [visibleSuccessModal, toggleVisibleSuccessModal] = useToggle(false);

  const {
    onSubmit,
    isPostCallMeLoading,
    error: isPostCallMeError,
    isPostCallMeSuccess,
  } = useCallMeFrom({
    entityId,
    entityName,
    price,
    currency,
    salesItemType,
    availabilityStatus,
    formCheckInDate,
    formCheckOutDate,
    hotelRoomList,
    token,
    onClose,
    onFormSendSuccess,
    itemCountryCode,
  });

  useSkipEffectOnMount(() => {
    if (isPostCallMeSuccess) {
      if (showSuccessModal) {
        toggleVisibleSuccessModal();
      } else {
        onClose();
      }
    }
  }, [isPostCallMeSuccess]);

  return (
    <>
      {!visibleSuccessModal ? (
        <LetUsCallYouModal
          isPostCallMeError={
            (isPostCallMeError as ApiError)?.body?.errors ??
            (isPostCallMeError ? [] : undefined)
          }
          onSubmit={onSubmit}
          onCancel={onClose}
          entityName={entityName}
          formCheckInDate={formCheckInDate}
          formCheckOutDate={formCheckOutDate}
          isPostCallMeLoading={isPostCallMeLoading}
          alertType={alertType}
        />
      ) : null}

      {showSuccessModal && visibleSuccessModal ? (
        <SuccessModal
          isVisible={visibleSuccessModal}
          title='Talebiniz alınmıştır. En kısa sürede satış danışmanımız tarafından aranacaksınız.'
          contentStyle={{ marginTop: 30 }}
          onCancel={() => {
            toggleVisibleSuccessModal();
            onClose();
          }}
        />
      ) : null}
    </>
  );
};

export default LetUsCallYou;
